import { getYearsOld } from "../../utils/functions/date-helper";
import { Tooltip } from "primereact/tooltip";
import { Avatar } from "primereact/avatar";

export const UserNameBodyTemplate = (rowData: any) => {
  return (
    <div className="flex align-items-center gap-2 w-full">
      <Tooltip target=".custom-target-icon" />
      <Avatar
        shape="circle"
        size="large"
        className={
          rowData.sex === "M"
            ? "text-white bg-blue-400"
            : "text-white bg-pink-400"
        }
        image={`${
          rowData
            ? rowData?.imageFormat + "," + rowData?.imageBase64
            : undefined
        }`}
        label={
          rowData
            ? `${rowData.firstName?.charAt(0).toUpperCase() ?? ""}${
                rowData.lastName?.charAt(0).toUpperCase() ?? ""
              }`
            : ""
        }
      />
      <span>
        {rowData.lastName}, {rowData.firstName}
        {rowData.birthDate && ` (${getYearsOld(rowData.birthDate.toString())})`}
      </span>
      <i
        className={`custom-target-icon pi ${
          rowData.activated || rowData.complete
            ? "true-icon pi-check-circle text-green-500"
            : "false-icon pi-times-circle text-red-500"
        }`}
        data-pr-tooltip={
          rowData.activated || rowData.complete ? "Completo" : "Incompleto"
        }
        data-pr-position="right"
      />
    </div>
  );
};
